import React from "react";

const OpeningsSVG = ({ height, width, fill = "none" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="4" fill="#F5F7FF" />
      <path
        d="M16.6666 20V18.6667C16.6666 17.9594 16.3857 17.2811 15.8856 16.781C15.3855 16.281 14.7072 16 14 16H9.99998C9.29274 16 8.61446 16.281 8.11436 16.781C7.61426 17.2811 7.33331 17.9594 7.33331 18.6667V20"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.3333C13.4727 13.3333 14.6666 12.1394 14.6666 10.6667C14.6666 9.19391 13.4727 8 12 8C10.5272 8 9.33331 9.19391 9.33331 10.6667C9.33331 12.1394 10.5272 13.3333 12 13.3333Z"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6667 19.9993V18.6659C20.6662 18.0751 20.4696 17.5011 20.1076 17.0341C19.7456 16.5672 19.2388 16.2336 18.6667 16.0859"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 8.08594C17.2403 8.2328 17.7487 8.5664 18.1118 9.03414C18.4748 9.50188 18.6719 10.0772 18.6719 10.6693C18.6719 11.2614 18.4748 11.8367 18.1118 12.3044C17.7487 12.7721 17.2403 13.1057 16.6667 13.2526"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpeningsSVG;
